import type { PreviewableDocument } from "../components/common/DocumentPreviewModal";

const DEFAULT_UPLOAD_BASE_URL = "https://admin.aida-dz.xyz/api/uploads";

export const uploadBaseUrl =
  (process.env.REACT_APP_UPLOAD_BASE_URL || DEFAULT_UPLOAD_BASE_URL).replace(
    /\/$/,
    "",
  );

export function resolveUploadedFileUrl(
  filePath?: string | null,
  folder?: string,
) {
  const value = String(filePath || "").trim();

  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;

  const normalizedPath = value.startsWith("/") ? value : `/${value}`;

  if (normalizedPath.startsWith("/api/uploads/")) {
    return `${uploadBaseUrl.replace(/\/api\/uploads$/i, "")}${normalizedPath}`;
  }

  if (normalizedPath.startsWith("/uploads/")) {
    return `${uploadBaseUrl}${normalizedPath.replace(/^\/uploads/i, "")}`;
  }

  if (folder) {
    return `${uploadBaseUrl}/${folder.replace(/^\/|\/$/g, "")}/${value.replace(
      /^\//,
      "",
    )}`;
  }

  return `${uploadBaseUrl}${normalizedPath}`;
}

export function getUploadedFilePreviewType(url: string): PreviewableDocument["type"] {
  const cleanUrl = url.split("?")[0].toLowerCase();

  if (/\.(jpg|jpeg|png|webp|gif|svg)$/i.test(cleanUrl)) return "image";
  if (/\.pdf$/i.test(cleanUrl)) return "pdf";

  return "other";
}

export function buildPreviewableDocument(
  filePath?: string | null,
  name?: string | null,
  folder?: string,
  fallbackName = "Document",
): PreviewableDocument | null {
  const url = resolveUploadedFileUrl(filePath, folder);

  if (!url) return null;

  return {
    url,
    name: name || filePath?.split("/").pop() || fallbackName,
    type: getUploadedFilePreviewType(url),
  };
}
